import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";
import device from '../../../../device.config';

const Row = ({ feed, partners, defaultOffers, onRemove, onUpdate}) => {
    return (<tr>
        <td style={{ textAlign: 'left' }}>{feed.id}</td>
        <td>{feed.name}</td>
        <td>{feed.type}</td>
        <td>{feed.auth}</td>
        <td>{feed.factor}</td>
        <td>{partners[feed.partnerId]}</td>
        <td>{defaultOffers[feed.defaultOfferId]}</td>
        <td>{feed.zone}</td>
        <td>{device[feed.device]}</td>
        <td>{feed.roi}</td>
        <td>{feed.cpm}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="info" onClick={() => onUpdate(feed)}>Update</Button>
                <Button bsStyle="danger" onClick={() => onRemove(feed.id)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdkBannerFeeds/components/Table/components/Row/index.js